import { Table } from 'antd';
import moment from 'moment';
import React, { FC } from 'react';
import { t_cpap_instructions } from 'types';

type Props = {
  moveTo: (itemId: string) => void;
  updateData?: t_cpap_instructions[];
  loading?: boolean;
};

const MyTable: FC<Props> = ({ updateData, moveTo, loading }) => {
  return (
    <div>
      <Table
        rowKey="i_id"
        onRow={(event) => {
          return {
            onClick: () => {
              moveTo(event?.i_id || '');
            },
          };
        }}
        columns={columns}
        dataSource={updateData}
        pagination={false}
        loading={loading}
      />
    </div>
  );
};

const columns: any = [
  {
    title: '医療機関',
    dataIndex: 'facility_name',
    key: 'facility_name',
    width: '20%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
          className: 'standardFont',
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: '患者ID',
    dataIndex: 'patient_id',
    key: 'patient_id',
    width: '20%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          className: 'standardFont',
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: '氏名',
    dataIndex: 'patient_name',
    key: 'patient_name',
    width: '20%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { background: 'rgba(246, 246, 246, 1)' },
          className: 'standardFont',
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: '設置日',
    key: 'installation_date',
    dataIndex: 'installation_date',
    width: '20%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { textAlign: 'right' },
          className: 'standardFont',
        },
        children: (
          <div>
            {moment(text, 'YYYY-MM-DDThh:mm:ss.SSSZ').format('YYYY年MM月DD日') === 'Invalid date'
              ? ''
              : moment(text, 'YYYY-MM-DDThh:mm:ss.SSSZ').format('YYYY年MM月DD日')}
          </div>
        ),
      };
    },
  },
  {
    title: '利用停止',
    key: 'suspension_flg',
    dataIndex: 'suspension_flg',
    width: '20%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          className: 'standardFont',
        },
        children:
          text === '1' ? (
            <div style={{ width: 90, margin: 'auto', padding: '5px 0', backgroundColor: 'rgb(216, 216, 216)' }}>
              利用停止
            </div>
          ) : null,
      };
    },
  },
];

export default MyTable;
